{
  "version": 1,
  "asset_id": "2f30e872-1d4a-432b-9251-1eddd6d3a8e3",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/2f30e872-1d4a-432b-9251-1eddd6d3a8e3/bypass-weight-loss-graph-1664.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/2f30e872-1d4a-432b-9251-1eddd6d3a8e3/bypass-weight-loss-graph-1664.webp",
  "original_filename": "bypass-weight-loss-graph-1664.webp",
  "size": 49706,
  "content_type": "image/webp",
  "created_at": "2026-10-04T16:12:41Z"
}
